module.exports = __webpack_public_path__ + "static/media/blackBackground.43056ad0.jpg";